module.exports = __webpack_public_path__ + "img/initialDashboard.87ab81af.png";